module.exports = "<div style={{ maxWidth: 360 }}>\n  <BubbleChat\n    text=\"Welcome to Aha Design System\"\n    time=\"16:23\"\n  />\n</div>;\n"